import React from "react";
import Select from "react-select";
import $ from "jquery";
import { Col } from "react-bootstrap";
import Tooltip from "@components/common/tooltip/main";
import "./styles/brandfolder_settings_default_sort_form";

export default class DefaultSortForm extends React.Component {
  state = {
    selectedSortName: this.props.sortName
  };

  updateSortOrder(order) {
    this.setState({ selectedSortName: order });
    let query;
    if (order === "name") {
      query = "name ASC";
    } else if (order === "updated") {
      query = "updated_at DESC";
    } else if (order === "created") {
      query = "created_at DESC";
    } else if (order === "position") {
      query = "position ASC";
    }

    $.ajax({
      type: "PUT",
      url: `/api/v3/brandfolders/${this.props.brandfolderKey}`,
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ data: { attributes: { default_order_method: query } } }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`);
      },
      success: () => {
        Notify.create({
          title: t("The default sort order has been updated for all users for this Brandfolder"),
          type: "success"
        });
      },
      error: () => {
        this.setState({ selectedSortName: this.props.sortName });
        Notify.create({
          title: t("An error occured and the default sort order was not changed. Please try again!"),
          type: "error"
        });
      }
    });
  }

  renderDropdown() {
    return (
      <Select
        name="download_as_options default-sort"
        value={this.state.selectedSortName}
        options={[
          { value: "position", label: t("Position") },
          { value: "name", label: t("Name") },
          { value: "updated", label: t("Updated") },
          { value: "created", label: t("Created") }
        ]}
        clearable={false}
        searchable={false}
        onChange={(option) => this.updateSortOrder(option.value)}
      />
    );
  }

  render() {
    return (
      <div className="brandfolder-settings-default-sort-form-component">
        <Col sm={12}>
          <div
            className="float-left"
            style={{ lineHeight: "35px", paddingRight: "10px" }}
          >
            <span
              style={{
                fontSize: "18px",
                display: "inline-block"
              }}
            >
              {t('Default Sort Option')}&nbsp;&nbsp;
            </span>
            <Tooltip
              tooltipId="default-sort-info"
              tooltipContent={t("Set the default sort option for all users that visit this Brandfolder or any of its Collections.")}
            >
              <span className="bff-tool-tip" />
            </Tooltip>
          </div>
          <div className="float-left" style={{ width: "200px", paddingRight: "10px" }}>
            {this.renderDropdown()}
          </div>
        </Col>
        <Col sm={12}>
          <hr />
        </Col>
      </div>
    );
  }
}
